import React from 'react';
import { ReverseButtonStyle } from './ReverseButton.styles';
import { GitCompareArrows } from 'lucide-react';
import { useIntl } from 'react-intl';

interface SaveButtonProps {
  onClick: () => void;
}

export const ReverseButton: React.FC<SaveButtonProps> = ({ onClick }) => (
  <ReverseButtonStyle
    onClick={onClick}
    aria-label={useIntl().formatMessage({ id: "reverse_direction" })}
    title={useIntl().formatMessage({ id: "reverse_direction" })}>
    <GitCompareArrows size={18} strokeWidth={2.5} />
  </ReverseButtonStyle>
);